<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table :isShowCondition="false" v-bind="$attrs" :name="$options.name" ref="yt" getUrl="web/equipment/check/standard/group/detail/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #top>
        <div style="padding-top: 10px ;">
          <el-descriptions>
            <el-descriptions-item :label="$t('dianjianfenzu')">
              {{ $attrs.group.group }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1')" type="primary">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"> </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row, null, beforeShowBianjiDialog)">
              {{ $t('bianji') }}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/equipment/check/standard/group/detail/delete')">
              {{ $t('shanchu') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
      <template #dianjianzhouqi="scope">
        {{ scope.row.remindType == 1 ? $t('antian') + '-' + scope.row.remind : (scope.row.remindType == 2?$t('anbanci') + '-' + scope.row.remind:scope.row.remind?$t('mei')+scope.row.remind:'')  }}

        <!-- {{ scope.row.remindType == 1 ? $t('antian') + '-' + scope.row.remind : $t('anbanci') + '-' + scope.row.remind }} -->
      </template>
    </yi_curd_table>
    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dianjianfenzu')" required="required">
            <el-input v-model="yt.editObj.group"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dianjianneirong')" required="required">
            <el-input type="textarea" v-model="yt.editObj.content"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dianjianzhouqi')" required="required">
            <el-input v-model="yt.editObj.remindTxt" suffix-icon="el-icon-arrow-down" :readonly="true" @click.native="showZhouqiDialog()"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('zhuyishixiang')">
            <el-input type="textarea" v-model="yt.editObj.attention"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button
            :loading="yt.editObj.loading"
            size="mini"
            @click="
              beforeAdd(yt.editObj);
              yt.req('POST', '/web/equipment/check/standard/group/detail/create');
            "
            type="primary"
          >
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('dianjianfenzu')" required="required">
            <el-input disabled v-model="yt.editObj.group"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dianjianneirong')" required="required">
            <el-input type="textarea" v-model="yt.editObj.content"></el-input>
          </el-form-item>
          <el-form-item :label="$t('dianjianzhouqi')" required="required">
            <el-input v-model="yt.editObj.remindTxt" suffix-icon="el-icon-arrow-down" :readonly="true" @click.native="showZhouqiDialog()"> </el-input>
          </el-form-item>
          <el-form-item :label="$t('zhuyishixiang')">
            <el-input type="textarea" v-model="yt.editObj.attention"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button :loading="yt.editObj.loading" size="mini" @click="yt.req('POST', '/web/equipment/check/standard/group/detail/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <!-- 班次 -->
      <template v-if="yt.editObj.action == 'banci'">
        <div class="dialog-scroller">
          <shift_setting :shift="yt.editObj"></shift_setting>
        </div>
      </template>
    </el-dialog>

    <!-- 点检周期弹框 -->
    <el-dialog v-if="isShowZhouQiDialog" :show-close="true" :title="$t('dianjianzhouqi')" :visible.sync="isShowZhouQiDialog" :close-on-click-modal="false" append-to-body="append-to-body" style="justify-content: center;">
      <el-form :inline="true" :model="yt.editObj" ref="form" size="mini" :label-width="labelWidth">
        <el-form-item :label="$t('tixingfangshi')" required label-width="200px">
          <el-select v-model="yt.editObj.remindType" @change="changeRemindType">
            <el-option v-for="(item, index) in modes" :key="index" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="yt.editObj.remindType == 3" :label="$t('tixingri')" required label-width="200px">
          <el-select v-model="yt.editObj.week">
            <el-option v-for="(item, index) in weekData" :key="index" :label="item.name" :value="item.week"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="yt.editObj.remindType == 1 || yt.editObj.remindType == 2 || yt.editObj.remindType == 3" v-for="(item, index) in yt.editObj.remindList" :key="index" :label="$t(item.name)" required label-width="200px">
          <el-time-picker v-model="yt.editObj.remindList[index]['time']" :placeholder="$t('qingxuanze')" format="HH:mm" value-format="HH:mm" :clearable="false"> </el-time-picker>
        </el-form-item>
        
        
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="closeZhouQiDialog()">{{ $t('quxiao') }}</el-button>
        <el-button size="mini" @click="save()" type="primary">
          {{ $t('baocun') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import shift_setting from '@@/pages/web/base/shift/shift_setting';
export default {
  name: 'web_base_check_standard',
  components: {
    shift_setting
  },
  created() {
    setTimeout(() => {
      this.yt.conditions.groupId = this.$attrs.group.id;
      this.yt.get(1);
      this.getShiftByCustomer();
      this.getCustomerList();
    }, 300);
  },
  data() {
    return {
      list: [],
      shiftList: [],
      columns: [
        {
          label: 'dianjianfenzu',
          prop: 'group',
          width: 130
        },
        {
          label: 'dianjianneirong',
          prop: 'content'
        },
        {
          label: 'zhuyishixiang',
          prop: 'attention'
        },
        {
          label: 'dianjianzhouqi',
          type: 'slot',
          width: 180
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 120,
          fixed: 'right'
        }
      ],
      weekData: [
        {
          name: this.$t('zhouyi'),
          week: '1'
        },
        {
          name: this.$t('zhouer'),
          week: '2'
        },
        {
          name: this.$t('zhousan'),
          week: '3'
        },
        {
          name: this.$t('zhousi'),
          week: '4'
        },
        {
          name: this.$t('zhouwu'),
          week: '5'
        },
        {
          name: this.$t('zhouliu'),
          week: '6'
        },
        {
          name: this.$t('zhouri'),
          week: '7'
        }
      ],
      isShowZhouQiDialog: false,
      labelWidth: '100px',
      timeList: []
    };
  },
  computed: {
    modes() {
      return [
        {
          label: this.$t('antian'),
          value: 1
        },
        {
          label: this.$t('anbanci'),
          value: 2
        },
        {
          label: this.$t('anzhou'),
          value: 3
        }
      ];
    }
  },
  // filters: {
  //   // 过滤点检周期
  //   filterRemind(value) {
  //     if (!isArray(value)) {
  //       return ''
  //     }
  //     if (value.length == 0) {
  //       return ''
  //     }
  //     if (value[0]['remindType'] == 1) {
  //       return '按天-' + value[0]['time']
  //     } else {
  //       return "按班次-" + value.map(item => {
  //         return item.name + item.time
  //       }).join(" ")
  //     }
  //   }
  // },
  watch: {
    // // 监听点检周期
    // "yt.editObj.remindType": {
    //   handler(n, o) {
    //     if (o !== undefined) {
    //       console.log('666', o)
    //       if (n === 2) {
    //         this.$set(this.yt.editObj, 'remindList', [])
    //         this.getTimeList()
    //       }
    //       if (n === 1) {
    //         let data = [{
    //           "name": this.$t('tixingshijian'),
    //           "remindType": 1,
    //           "time": ""
    //         }]
    //         this.$set(this.yt.editObj, 'remindList', data)
    //       }
    //     }
    //   },
    //   immediate: false
    // },
    // 监听点检周期弹框
    isShowZhouQiDialog: {
      handler(n, o) {
        if (n) {
          if (this.yt.editObj.remindList && this.yt.editObj.remindList.length > 0) {
            // 早班
            if (this.yt.editObj.remindList[0]['remindType'] === 1||this.yt.editObj.remindList[0]['remindType'] === 3) {
              if(this.yt.editObj.remindList[0]['remindType'] === 3){
                this.$set(this.yt.editObj, 'week', this.yt.editObj.remindList[0]['week'])
                this.yt.editObj.week = this.yt.editObj.remindList[0]['week']
              }
              this.$set(this.yt.editObj, 'remindList', [
                {
                  name: this.$t('tixingshijian'),
                  remindType: this.yt.editObj.remindList[0]['remindType'],
                  time: this.yt.editObj.remindList[0]['time'],
                  week: this.yt.editObj.remindList[0]['week']
                }
              ]);
            } else {
              const data = [];
              for (let i = 0; i < this.yt.editObj.remindList.length; i++) {
                data.push({
                  name: this.yt.editObj.remindList[i]['shift']['name'].concat(this.$t('tixingshijian')),
                  remindType: 2,
                  time: this.yt.editObj.remindList[i]['time'],
                  shiftId: this.yt.editObj.remindList[i]['shift']['id']
                });
              }
              this.$set(this.yt.editObj, 'remindList', data);
            }
          } else {
            if (this.yt.editObj.remindType === 1) {
              this.$set(this.yt.editObj, 'remindType', 1);
              let data = [
                {
                  name: this.$t('tixingshijian'),
                  remindType: 1,
                  time: ''
                }
              ];
              this.$set(this.yt.editObj, 'remindList', data);
            }
          }
        }
      },
      immediate: false
    }
  },
  methods: {
    beforeAdd(editObj) {
      editObj.groupId = this.$attrs.group.id;
    },
    changeRemindType(value) {
      this.$set(this.yt.editObj, 'remindTxt', '');
      this.$set(this.yt.editObj, 'remindList', []);
      if (value === 2) {
        this.getTimeList();
      }
      // if (value === 3) {
      //   this.getWeekList();
      // }
      if (value === 1 || value === 3) {
        let data = [
          {
            name: this.$t('tixingshijian'),
            remindType: value,
            time: ''
          }
        ];
        this.$set(this.yt.editObj, 'remindList', data);
      }
    },
    beforeShowBianjiDialog() {
      let label = '';
      if (this.yt.editObj.remindType == 1) {
        label = this.$t('antian') + '-' + this.yt.editObj.remindList[0]['time'];
      }
      if (this.yt.editObj.remindType == 2) {
        label = this.$t('anbanci') + '-' + this.yt.editObj.remind;
        // label = this.$t('anbanci') + "-" + this.yt.editObj.remindList.map(item => {
        // 	return item.shift.name + item.time
        // }).join(" ")
      }
      if (this.yt.editObj.remindType == 3) {
        let weekText = '';
        switch (this.yt.editObj.remindList[0].week) {
          case '1':
            weekText = this.$t('zhouyi');
            break;
          case '2':
            weekText = this.$t('zhouer');
            break;
          case '3':
            weekText = this.$t('zhousan');
            break;
          case '4':
            weekText = this.$t('zhousi');
            break;
          case '5':
            weekText = this.$t('zhouwu');
            break;
          case '6':
            weekText = this.$t('zhouliu');
            break;
          case '7':
            weekText = this.$t('zhouri');
            break;
        }
        label = this.$t('mei') + weekText + this.yt.editObj.remindList[0]['time'];
        // label = this.$t('anbanci') + "-" + this.yt.editObj.remindList.map(item => {
        // 	return item.shift.name + item.time
        // }).join(" ")
      }
      this.$set(this.yt.editObj, 'remindTxt', label);
      return this.yt.editObj;
    },
    async getShiftByCustomer() {
      let response = await this.http.get('/web/setting/shift/page', {
        params: {
          pageNum: 1,
          pageSize: 10000
        }
      });
      this.shiftList = response.data.rows;
    },
    // 重置
    clear() {
      this.yt.conditions = {
        pageNum: 1,
        pageSize: 10
      };
      this.yt.get(1);
    },
    // 保存点检周期
    save() {
      this.isShowZhouQiDialog = false;
      let label = '';
      if (this.yt.editObj.remindType == 1) {
        label = this.$t('antian') + '-' + this.yt.editObj.remindList[0]['time'];
      }
      console.log(this.yt.editObj.remindList);
      if (this.yt.editObj.remindType == 2) {
        label =
          this.$t('anbanci') +
          '-' +
          this.yt.editObj.remindList
            .map(item => {
              return item.name + item.time;
            })
            .join(' ');
      }
      //按周
      if (this.yt.editObj.remindType == 3) {
        let week = this.yt.editObj.week;
        let weekText = '';
        switch (week) {
          case '1':
            weekText = this.$t('zhouyi');
            break;
          case '2':
            weekText = this.$t('zhouer');
            break;
          case '3':
            weekText = this.$t('zhousan');
            break;
          case '4':
            weekText = this.$t('zhousi');
            break;
          case '5':
            weekText = this.$t('zhouwu');
            break;
          case '6':
            weekText = this.$t('zhouliu');
            break;
          case '7':
            weekText = this.$t('zhouri');
            break;
        }
        label = this.$t('mei') + weekText + this.yt.editObj.remindList[0]['time'];
        this.yt.editObj.remindList[0]['week'] = this.yt.editObj.week
      }
      this.$set(this.yt.editObj, 'remindTxt', label);
    },
    // 打开点检周期
    showZhouqiDialog() {
      this.isShowZhouQiDialog = true;
    },
    // 关闭点检周期
    closeZhouQiDialog() {
      this.isShowZhouQiDialog = false;
    },
    // 获取班次
    async getTimeList() {
      let response = await this.http('/web/setting/shift/getShiftByCustomer');
      if (response.code == 200 && response.data.length != 0) {
        let data = [];
        for (let i = 0; i < response.data.length; i++) {
          data.push({
            name: response.data[i]['name'].concat(this.$t('tixingshijian')),
            remindType: 2,
            shiftId: response.data[i]['id'],
            time: ''
          });
        }
        this.$set(this.yt.editObj, 'remindList', data);
      }
    },
    // 过滤点检周期
    filterRemind(value) {
      if (!isArray(value)) {
        return '';
      }
      if (value.length == 0) {
        return '';
      }
      if (value[0]['remindType'] == 1) {
        return this.$t('antian') + '-' + value[0]['time'];
      } else {
        return (
          this.$t('anbanci') +
          '-' +
          value
            .map(item => {
              return item.name + item.time;
            })
            .join(' ')
        );
      }
    }
  }
};
</script>
